export default __webpack_public_path__ + "static/media/Lato-Bold.825d6d75.eot";